import React from 'react';
import useRequest from '../../utils/request/useRequest';
export var AppsContext = React.createContext({});
export var useAppsProvider = function useAppsProvider() {
  var apps = useRequest('/backend/microservices2');
  return apps;
};

var useApps = function useApps() {
  var apps = React.useContext(AppsContext);
  return apps;
};

export default useApps;